import NetworkService from './network.service';
import { NotificationSettings } from '../modules/notification/interface';
class NotificationService {
    
    static createOrUpdateNotification = async (notificationData: NotificationSettings & {companyId: number}) => {
        let url = `api/common-service/notification/permissions`;
        let data = await NetworkService.post(url, notificationData);
        return data && data.data ? data.data : data;
    };

    static getCompanyNotificationSetting = async () => {
        let url = `api/common-service/notification/permissions`;
        let data = await NetworkService.get(url, {});
        return data && data.data ? data.data : data;
    };
}
export default NotificationService;
